import { useRouter } from 'next/compat/router';
import { getAppInstance } from '@/utils/api/app';
import type { RawAxiosRequestHeaders } from 'axios';
import { getOperation } from '@/utils/getOperation';
import { getDatoEnvironment } from '@/utils/dato/environment';

export const useFetcher = <TData, TVariables>(query: string) => {
  const router = useRouter();

  return async (variables?: TVariables) => {
    const operation = getOperation(query);

    const headers: RawAxiosRequestHeaders = {
      'Content-Type': 'application/json',
      'x-operation-name': operation,
      'X-Exclude-Invalid': true,
    };

    if (router?.isPreview) {
      headers['x-include-drafts'] = 'true';
    }

    // Pin to the release's DatoCMS environment (e.g. prod-0-0-1234, derived from
    // the app version). /api/dato-graphql proxies this request straight through
    // to DatoCMS, so the header set here is what reaches DatoCMS.
    const environment = getDatoEnvironment();

    if (environment) {
      headers['x-environment'] = environment;
    }

    const { data } = await getAppInstance().post<{ data: TData }>(
      '/dato-graphql',
      {
        operationName: operation,
        variables,
        query,
      },
      { headers },
    );

    return data.data;
  };
};
